import i18n from '@/plugins/vuei18n'

export default {
  INACTIVE: 'inactive',
  WORKER: 'worker',
  CREATOR: 'creator',
  LEADER: 'leader',
  ADMIN: 'admin',
  properties: {
    'inactive': { name: 'inactive', status: 0, label: i18n.t('roles.inactive') },
    'worker': { name: 'worker', status: 10, label: i18n.t('roles.worker') },
    'creator': { name: 'creator', status: 10, label: i18n.t('roles.creator') },
    'leader': { name: 'leader', status: 10, label: i18n.t('roles.leader') },
    'admin': { name: 'admin', status: 10, label: i18n.t('roles.admin') }
  },
  inUse: {
    'inactive': { name: 'inactive', status: 0, label: i18n.t('roles.inactive') },
    'worker': { name: 'worker', status: 10, label: i18n.t('roles.worker') },
    'admin': { name: 'admin', status: 10, label: i18n.t('roles.admin') }
  }
}
